import { Box } from '@mui/material';
import type { FieldMode } from '../../../hooks/useCaseField';
import ProcedureTable from './ProcedureTable';

interface ProceduresSectionProps {
  mode: FieldMode;
}

const ProceduresSection: React.FC<ProceduresSectionProps> = ({ mode }) => {
  return (
    <Box sx={{ mb: 2.5 }}>
      <ProcedureTable mode={mode} />
    </Box>
  );
};

export default ProceduresSection;

